export default __webpack_public_path__ + "static/media/hex-right-shadow.a5133952.svg";